import {PaymentCard} from "@ferry/journey-services";
import * as moment from "moment";
import * as React from "react";
import {renderCardTypeName} from "../../../../../CommonFunctions";

interface IProps {
    mainCard?: PaymentCard
}

export class CreditCardSection extends React.Component<IProps> {

    constructor(props: any) {
        super(props);
    }

    public render() {

        if (this.props.mainCard) {
            return (
                <div className="mt-3 credit-card-section" id={`card-${(this.props.mainCard.id).toString()}`}>
                    <div>
                        <div id="cardType" className="font-weight-bold mb-2">{renderCardTypeName(this.props.mainCard)} ending in <span id="cardNumber">{this.props.mainCard.cardNumberObfuscated.split('******')[1]}</span></div>
                    </div>
                    <div className="mt-1"><span className="font-weight-bold"> Expiry
                        date: </span><span id="cardExpiryDate">{moment.monthsShort(this.props.mainCard.expiryMonth - 1)} '{this.props.mainCard.expiryYear}</span></div>
                </div>
            )
        } else {
            return (<div>No cards added to account</div>);
        }
    }
}
